const SET_DANH_SACH_TEMPLATE = (state, danhSachTemplate) => {
  state.danhSachTemplate = danhSachTemplate;
};

const SET_CHI_TIET_TEMPLATE = (state, chiTietTemplate) => {
  state.chiTietTemplate = chiTietTemplate;
};
const SET_DANH_SACH_HE_THONG_LOG = (state, danhSachQuanLyHeThongLog) => {
  state.danhSachQuanLyHeThongLog = danhSachQuanLyHeThongLog;
};
const SET_DANH_SACH_HE_THONG_CRUD = (state, danhSachQuanLyHeThongCRUD) => {
  state.danhSachQuanLyHeThongCRUD = danhSachQuanLyHeThongCRUD;
};
export default {
  SET_DANH_SACH_TEMPLATE,
  SET_CHI_TIET_TEMPLATE,
  SET_DANH_SACH_HE_THONG_LOG,
  SET_DANH_SACH_HE_THONG_CRUD,
};
